import webNewsServiceGen from "./generated/webNewsServiceGen";

class webNewsService extends webNewsServiceGen {
}

export default webNewsService;